import React from 'react'
import { useCategoriesManager } from '../../hooks/useCategoriesManager'

interface CategoriesManagerProps {
  categories: string[]
  onCategoriesChange: (categories: string[]) => void
}

const CategoriesManager: React.FC<CategoriesManagerProps> = ({ categories, onCategoriesChange }) => {
  const { newCategory, setNewCategory, handleAddCategory, handleRemoveCategory } =
    useCategoriesManager(categories, onCategoriesChange)

  return (
    <div className='mb-4'>
      <label className='form-label'>Kategorie *</label>
      <div className='input-group mb-2'>
        <input
          type='text'
          className='form-control'
          placeholder='Dodaj kategorię'
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddCategory())}
        />
        <button
          type='button'
          className='btn btn-outline-primary'
          onClick={handleAddCategory}
        >
          Dodaj
        </button>
      </div>

      <div className='mt-3'>
        {categories.length > 0
          ? (
              categories.map((category, index) => (
                <span key={index} className='badge bg-success me-2 mb-2 p-2 d-inline-flex align-items-center gap-2'>
                  <span>{category}</span>
                  <button
                    type='button'
                    className='border-0 bg-transparent text-white p-0 m-0'
                    onClick={() => handleRemoveCategory(category)}
                    aria-label='Usuń'
                    style={{ cursor: 'pointer', fontSize: '1.2em', lineHeight: '1' }}
                  >
                    ×
                  </button>
                </span>
              ))
            )
          : (
            <div className='text-muted small'>Brak dodanych kategorii. Dodaj przynajmniej jedną.</div>
            )}
      </div>
    </div>
  )
}

export default CategoriesManager
